export function getNodeOffset(node) {
  var parent = node.parentNode;
  if (!parent) {
    return 0;
  }
  var _node$getBoundingClie = node.getBoundingClientRect(),
    left = _node$getBoundingClie.left;
  var _parent$getBoundingCl = parent.getBoundingClientRect(),
    parentLeft = _parent$getBoundingCl.left;
  return left - parentLeft;
}